import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { DIMENSIONS } from '../../../styles/constants';
import { useStyles } from '../styles';
import Paper from '../../Paper/Paper';
import Grid from '@material-ui/core/Grid';
import WdValidatorSkeleton from './WdValidatorSkeleton';

const QuickFiltersSkeletonWdSupported = ({ numberOfRows }) => {
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Paper>
			<Grid
				style={{
					maxWidth: 1253,
					marginRight: '30px'
				}}>
				<div className={classes.tableBarBottom}>
					<Skeleton width="170px" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
				</div>
				<Grid container>
					<Grid style={{ width: '270px', paddingRight: '4%' }}>
						<div>
							<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} className={classes.skeletonNarrow} />
						</div>

						<div>
							<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} className={classes.skeletonNarrow} />
						</div>

						<div>
							<Skeleton width="100%" height={DIMENSIONS.SKELETON_TABLE_ROW_HEIGHT} className={classes.skeletonNarrow} />
						</div>
					</Grid>
					<Grid style={{ width: '690px' }}>
						{[...Array(numberOfRows)].map((_e, index) => (
							<div key={'table-skeleton-row-' + index} className={classes.tableRowButton}>
								<Skeleton width={`calc(100% - ${theme.spacing(3)})px`} height="100%" className={classes.skeleton} />
							</div>
						))}
					</Grid>
					<Grid style={{ width: '270px' }}>
						<div>
							<Skeleton width="100%" height={DIMENSIONS.NAVBAR_HEIGHT} className={classes.skeletonNarrow} />
						</div>

						<div>
							<Skeleton width="100%" height={DIMENSIONS.NAVBAR_HEIGHT} className={classes.skeletonNarrow} />
						</div>
						<div>
							<Skeleton width="100%" height={DIMENSIONS.NAVBAR_HEIGHT} className={classes.skeletonNarrow} />
						</div>
						<div>
							<Skeleton width="100%" height={DIMENSIONS.NAVBAR_HEIGHT} className={classes.skeletonNarrow} />
						</div>
					</Grid>
				</Grid>
				<WdValidatorSkeleton />
				<div className={classes.tableBarBottom}>
					<Skeleton height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} width={'60px'} />
				</div>
			</Grid>
		</Paper>
	);
};

QuickFiltersSkeletonWdSupported.propTypes = {
	numberOfRows: PropTypes.number.isRequired
};

export default QuickFiltersSkeletonWdSupported;
